<template>
    <el-drawer
        title="添加卡劵"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="40%"
        :before-close="close">
        <div class="panel form">
            <el-form ref="form" :model="form" label-width="150px" class="edit_form">
                <el-form-item label="班级" v-check="{'必选': !form.classId}">
                    <el-select v-model="form.classId" filterable placeholder="班级">
                        <el-option
                            v-for="item in classOptin"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="数量" v-check="{'必填': !form.amount}">
                   <el-input-number v-model="form.amount"  :min="1"  label="" ></el-input-number>
                </el-form-item>
                <el-form-item label="时长" v-check="{'必填': !form.changeCount}">
                    <el-input-number v-model="form.changeCount"  :min="1"  label="" ></el-input-number>
                    <span style="color:#F56C6C" >
                        *每人开通的天数
                    </span>
                </el-form-item>
                <el-form-item v-if="totalDay > 0">
                    <span style="color:#F56C6C" >
                        * 本次扣除时长为{{totalDay}}
                    </span>
                 </el-form-item>
                <el-form-item label="剩余时长">
                    {{form.leftChargeCount}}天
                </el-form-item>
            </el-form>
        </div>
        <span  class="fx fx-center">
            <el-button type="primary" @click="sub()" :disabled="subDisabled">确 定</el-button>
            <el-button @click="close()">取 消</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>

</style>


<script>


    export default {
        props: [
            "onClose",
            "classId", //指定班级id

        ],
        data() {
            return {
                show: false,
                form: {
                    leftChargeCount:0
                },
                classOptin:{},
                classFrom:{useType:2},
                needRefreshParent: false,
                selfInfo:{},
                totalDay:'',
                subDisabled:false,
            }

        },
        watch: {
            "form": {
                handler: function (newValue) {
                    if(this.form.amount > 0 && this.form.changeCount > 0){
                        this.totalDay = this.form.amount * this.form.changeCount
                    }
                },
                deep: true
            }
        },

        methods: {
            close() {
                if (this.needRefreshParent) {
                    this.$emit("submit");
                } else {
                    this.$emit("close");
                }
            },
            sub() {
                this.subDisabled = true;
                this.$ajaxPost("/cardCoupon/addCards", {
                    form: this.form
                }, (data) => {
                    this.$emit("submit", data.result);
                    this.needRefreshParent = true;
                    this.$showSuccess("保存成功");
                })
                return false;
            },
            loadClassOptin() {
                this.$ajaxPost("/class/list",{form:this.classFrom}, (data) => {
                    this.classOptin = data.result;
                })
            },
            loadInstitution(){
                this.$ajaxGet("/institution/getInstitutionOne", (data) => {
                    this.form.leftChargeCount = data.result.leftChargeCount;
                })
            },
        },
        mounted() {
            this.show = true;
        },
        created() {
            //检测页面打开的时候，是否指定了班级和学生
            this.loadClassOptin();
            this.loadInstitution();
        }


    }
</script>

